import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel, TextareaAutosize,
    Typography,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { FusioningList } from '../TitleList';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectBalelist, selectChanllanId, selectClothIsInfo, selectClothIssue, selectCutReturnlist, selectEmployees, selectFirm, selectItemAvg, selectItems, selectMasterMlist, selectMemoNo, selectSONOinfolist } from '../Selectors/Master/ItemSelectors';
import { fetchSORegister } from '../../Store/PHPSlice/Sale/SaleOrder';
import { InsertCuttingEntry } from '../../Store/PHPSlice/Cutting/clothIssue';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { errorStyles } from '../../Utils/table';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { fetchCuttingReturnlist2, fetchMasterMlist } from '../../Store/PHPSlice/Cutting/cuttingApi';
import { fetchMemoNo } from '../../Store/PHPSlice/Cutting/SOMcutting';
import { fetchItemAvgData } from '../../Store/PHPSlice/ItemAvg';
import axios from 'axios';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Preview from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchCuttingMemo, fetchNumberingMemo, InsertNumberingEntry } from '../../Store/PHPSlice/Numbering/numberingApi';
import { selectCtInwardMemo, selectFusionMemo, selectNumMemo, selectNumMemoFusion } from '../Selectors/TrackSelector/TrackSelector';
import { fetchEmployeeData } from '../../Store/PHPSlice/Employee';
import { fetchFusionMemo, fetchNumberMemoforFusion, InsertFusionEntry } from '../../Store/PHPSlice/Fusioning/fusioningApi';



const FusioningEntry = () => {

    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        firmId: '',
        dt: getCurrentDate(),
        firm: '',
        memo: '',
        sono: '0',
        soId: '0',
        empNm: '',
        totQty: 0,
        nId: '',
        ctInwId: '',
        userId: userdata?.ID
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        master: fetchMasterMlist,
        sono: fetchSORegister,
        firm: fetchCompanyData,
        empNm: fetchEmployeeData
        // Add more mappings if needed
    };
    const [itemSize, setItemSize] = useState([]);

    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const [tableNumSize, setTableNumSize] = useState([]);

    const [loading, setLoading] = useState(false);

    const balelist = useSelector(selectBalelist);

    const masterMlist = useSelector(selectMasterMlist);
    const inwardMemo = useSelector(selectCtInwardMemo);
    const numMemo = useSelector(selectFusionMemo);
    const inwdata = useSelector(selectCutReturnlist);
    const empList = useSelector(selectEmployees);
    const numInwlist = useSelector(selectNumMemoFusion);
    const firmlist = useSelector(selectFirm);
    // console.log(inwdata)
    useEffect(() => {
        dispatch(fetchMasterMlist());
        dispatch(fetchCuttingMemo());
        dispatch(fetchFusionMemo());
        dispatch(fetchEmployeeData());
        // dispatch(fetchNumberMemoforFusion());
        dispatch(fetchCompanyData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (numMemo.data) {
            const item = numMemo.data.memo;
            setFormData(prev => ({
                ...prev,
                memo: item
            }))
        }

    }, [numMemo]);


    const handleQtychange = (index, event) => {
        let { value } = event.target;

        // Allow only numeric input
        if (!/^\d*$/.test(value)) return; // Reject anything that's not a number

        const balQty = Number(itemSize[index].balQty || 0);
        const enteredQty = Number(value || 0);

        // Prevent value greater than balQty
        if (enteredQty > balQty) return;

        // Clone and update state
        const updatedItemSize = [...itemSize];
        updatedItemSize[index].issqty = value;
        setItemSize(updatedItemSize);

        const totqty = updatedItemSize?.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);


        setFormData(prev => ({
            ...prev,
            totQty: totqty
        }));
    };


    const fetchNumberingData = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getNumberingMergeQtydata&nId=${id}`);
            // console.log(response?.data)
            const item = response?.data?.data;
            setFormData(prev => ({
                ...prev,
                itemNm: item?.itemNm,
                mclothNm: item?.mclothNm,
                m1clothNm: item?.m1clothNm,
                m2clothNm: item?.m2clothNm,
                m3clothNm: item.m3clothNm,
                itemId: item.itemId,
                mcloth: item?.mCloth,
                m1cloth: item?.m1Cloth,
                m2cloth: item?.m2Cloth,
                m3cloth: item?.m3Cloth,
                ctInwId: item?.ctInwId,
                soId: item?.soId,
                sono: item?.sono,
                returnMemo: item?.returnMemo || ''
            }));
            setItemSize(response?.data?.info);

        } catch (error) {
            console.error('Error fetching title list:', error);

        }
    };
    // console.log(itemSize)

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };



    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        // console.log(dropdownType)
        switch (dropdownType) {

            case 'nId':
                if (value) {
                    fetchNumberingData(value);
                }
                break;

            case 'firmId':
                if (value) {
                    dispatch(fetchNumberMemoforFusion(value));
                }
                break;

            default:
                break;
        };
    };


    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };



    function convertIntoOneObject(formData, itemSize) {
        return {
            dt: formData.dt,
            fmemo: formData.memo,
            itemId: formData.itemId,
            mcloth: formData.mcloth,
            m1cloth: formData.m1cloth,
            m2cloth: formData.m2cloth,
            m3cloth: formData.m3cloth,
            soId: formData.soId,
            empId: formData.empNm,
            userId: formData.userId,
            totQty: formData.totQty,
            nId: formData.nId,
            ctInwId: formData.ctInwId,
            itemSize: itemSize,
            firmId: formData.firmId
        };
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.empNm === "") {
            alert('Select Employee.');
            return;
        }

        // console.log(typeof formData.totQty)
        if (formData.totQty === 0) {
            alert('Please Enter Qty.');
            return;
        }

        setLoading(true);
        try {
            const postobj = convertIntoOneObject(formData, itemSize);
            // console.log(postobj);

            const result = await dispatch(InsertFusionEntry(postobj)).unwrap();
            console.log('POST request successful!', result);
            if (result?.msg === 'Memo already exists') {
                alert('Fusion Already Exists!');
                window.location.reload();
            } else {
                alert("Fusion added successfully");
                window.location.reload();
            }
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    const handleNewEmployee = () => {
        window.open(`/new-emp-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownEmployeelist = [
        {
            label: 'Employee',
            id: 'empNm',
            options: empList?.data?.filter((item) => item.departNm === 'FUSIONING') || [],
            value: formData.empNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'empNm', value: newValue ? newValue.ID : '' } }, 'empNm'),
            getOptionLabel: (option) => option.empNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNewEmployee(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('empNm'),
            handleDropdownClose: () => handleDropdownClose('empNm'),
        }
    ];


    const dropdownOrdType = [
        {
            label: 'Firm',
            id: 'firmId',
            options: firmlist?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }
        ,
        {
            label: 'Numbering Memo',
            id: 'nId',
            options: numInwlist?.data || [],
            value: formData.nId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'nId', value: newValue ? newValue.ID : '' } }, 'nId'),
            getOptionLabel: (option) => `${option.numMemo} - ${option.itemNm}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }
    ];


    // console.log(itemM1Avgs)

    return (
        <>
            <Titlebar data={FusioningList} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Fusioning Entry</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Fusion No', name: 'memo', type: 'readOnly' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }


                                {/* <Grid item xs={12} md={6}>

                                </Grid> */}

                                {/* {[
                                { label: 'Barcode', name: 'barcd', type: 'barcd' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))} */}


                                {[
                                    { label: 'SO No.', name: 'sono', type: 'readOnly' },
                                    { label: 'Item', name: 'itemNm', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {[
                                    { label: 'Main Cloth', name: 'mclothNm', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {[
                                    { label: 'Match-1', name: 'm1clothNm', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {[
                                    { label: 'Match-2', name: 'm2clothNm', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {[
                                    { label: 'Match-3', name: 'm3clothNm', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    dropdownEmployeelist && dropdownEmployeelist?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }
                                {[

                                    { label: 'Total Qty.', name: 'totQty', type: 'readOnly' },
                                    { label: 'Numbering Inw Memo', name: 'returnMemo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || '0'}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {itemSize.length > 0 && (
                                    <Grid item xs={10} md={11}>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                        {itemSize?.map((size, index) => (
                                                            <TableCell
                                                                key={index}
                                                                sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {size.size}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell
                                                            sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                            align='center'
                                                        >
                                                            Given Qty.
                                                        </TableCell>
                                                        {itemSize?.map((size, index) => (
                                                            <TableCell
                                                                key={index}
                                                                sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {size.balQty}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>


                                                    <TableRow>
                                                        <TableCell
                                                            sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                            align='center'
                                                        >
                                                            Issue Qty.
                                                        </TableCell>
                                                        {itemSize?.map((size, index) => (
                                                            <TableCell
                                                                key={index}
                                                                sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                <input
                                                                    type="text"
                                                                    value={size?.issqty}
                                                                    placeholder="0"
                                                                    onChange={(e) => handleQtychange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                )}




                                {itemSize?.length > 0 &&

                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default FusioningEntry;
